import React, { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'
import './TwitterCallback.css' // 样式文件

const TwitterCallback: React.FC = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const handleTwitterCallback = () => {
      try {
        const oauth_token = searchParams.get('oauth_token')
        const oauth_verifier = searchParams.get('oauth_verifier')
        const error = searchParams.get('error')
        const denied = searchParams.get('denied')

        // 检查是否有错误
        if (error || denied) {
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'twitter_oauth_error',
                error: error || 'User denied authorization'
              },
              window.location.origin
            )
          }
          window.close()
          return
        }

        // 检查OAuth参数
        if (oauth_token && oauth_verifier && window.opener) {
          // 发送成功数据给父窗口
          window.opener.postMessage(
            {
              type: 'twitter_oauth_success',
              oauth_token: oauth_token,
              oauth_verifier: oauth_verifier
            },
            window.location.origin
          )
        } else {
          // 参数不完整
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'twitter_oauth_error',
                error: 'Missing OAuth parameters'
              },
              window.location.origin
            )
          }
        }

        // 关闭弹窗
        window.close()
      } catch (err) {
        console.error('Twitter callback error:', err)
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'twitter_oauth_error',
              error: 'Callback processing failed'
            },
            window.location.origin
          )
        }
        window.close()
      }
    }

    // 执行回调处理
    handleTwitterCallback()
  }, [searchParams])

  return (
    <div className="twitter-callback-container">
      <div className="twitter-callback-spinner"></div>
      <div>Completing Twitter login...</div>
    </div>
  )
}

export default TwitterCallback
